export const config = {
  data() {
    return {
      columns: []
    };
  },
  mounted() {
    let columns = [
      {
        title: '续费周期-续费年度',
        key: 'needPayDate',
        align: 'center',
        minWidth: 140,
        render(h, params) {
          const text = params.row.needPayDate?.replace(/-/g, '/') + ' - ' + params.row.payNum;
          return <span>{text}</span>;
        }
      },

      {
        title: '保单数',
        key: 'policyNum',
        align: 'center',
        width: 100
      },
      {
        title: '结算应收保费/结算实收保费',
        minWidth: 190,
        key: 'settlementFee',
        align: 'center',
        render(h, params) {
          return (
            <span>
              {params.row.settlementFee || 0} / {params.row.settlementPayFee || 0}
            </span>
          );
        }
      },
      {
        title: '继续率',
        key: 'renewalRateStr',
        align: 'center',
        width: 100
      },
      {
        title: '是否达标',
        slot: 'isReachStandard',
        align: 'center',
        width: 110
      },
      {
        title: '是否确认',
        slot: 'isSure',
        align: 'center',
        width: 110,
        renderHeader: (h, params) => {
          return (
            <div>
              <span>是否确认</span>
              <Poptip trigger="hover" placement="top" transfer-class-name="my-poptip left0" transfer={true} offset={3}>
                <Icon style="color:#A8ADB7;margin-left:4px;" type="md-help-circle" />
                <div slot="content">
                  <p>财务是否确认此继续率</p>
                </div>
              </Poptip>
            </div>
          );
        },
      },
      {
        title: '续期规则',
        key: 'configName',
        align: 'center',
        minWidth: 160,
      },
      {
        title: '继续率要求',
        key: 'renewalRateStandardStr',
        align: 'center',
        width: 120,
      },
      {
        title: '结算日期',
        key: 'commissionPeriod',
        align: 'center',
        width: 120,
        render(h, params) {
          const text = params.row.commissionPeriod?.replace(/-/g, '/');
          return <span>{text}</span>;
        }
      },
      {
        title: '结算状态',
        slot: 'balanceStatus',
        align: 'center',
        width: 110,
      },
      {
        title: '操作',
        slot: 'action',
        align: 'center',
        width: 100,
        fixed: 'right'
      }
    ];

    this.columns = columns;
  },
  methods: {}
};
